import React from 'react';
import SectionHeader from '@components/section-header/SectionHeader';
import classnames from 'classnames';
import './section.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  isRequired?: boolean;
  isSubsection?: boolean;
  label?: string | React.ReactNode;
};

const Section = ({
  children,
  className,
  headerClassName,
  isRequired = false,
  isSubsection = false,
  label,
  ...rest
}: Props) => {
  const containerStyles = classnames('section-container', className);

  return (
    <div className={containerStyles} {...rest}>
      {label && (
        <SectionHeader className={headerClassName} isSubsection={isSubsection} isRequired={isRequired}>
          {label}
        </SectionHeader>
      )}
      <div className='section-content'>{children}</div>
    </div>
  );
};

export default Section;
